import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { CountryModel } from '../models/country.model';

export class CountriesApiService extends ApiService {
  static endpoint = 'countries';

  /**
   * @param {Number|null} countryId
   * @return {String}
   * @protected
   */
  static buildCountryUrl(countryId = null) {
    return this.buildUrl(countryId);
  }

  /**
   * @param {String|Number} countryId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CountryModel>>}
   * @public
   */
  static async get(countryId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildCountryUrl(countryId), {
      ...config,
      dataModel: CountryModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String} countryId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CountryModel>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildCountryUrl(), {
      ...config,
      dataModel: CountryModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CountryModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildCountryUrl(), data, {
      ...config,
      dataModel: CountryModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} countryId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CountryModel>>}
   * @public
   */
  static async patch(countryId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildCountryUrl(countryId), data, {
      ...config,
      dataModel: CountryModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} countryId
   * @param {Object} config
   * @return {Promise<HttpResponse>}
   * @public
   */
  static async delete(countryId, config = {}) {
    return HttpApiClient.delete(this.buildCountryUrl(countryId), { ...config });
  }
}
